<template>
	<div
		class="RecoverPassword is-flex is-align-items-center is-flex-direction-column"
	>
		<div style="width: 500px; max-width: 90%; padding-top: 15px;" class="mb-5">
			<img src="@/assets/logo.svg" />
		</div>
		<div class="RecoverPassword-Form">
			<form @submit.prevent="onSubmit">
				<div class="p-6">
					<h1 class="RecoverPassword-Title">{{ $t('resetpassword.title') }}</h1>
					<div>
						<div class="field" style="opacity: 0.6;">
							<label class="label has-text-white">{{ $t('resetpassword.email_label') }}</label>
							<p class="control has-icons-left">
								<input
									required
									class="input"
									type="text"
									placeholder="$t('resetpassword.email_placeholder')
									v-model="formData.email"
									disabled
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-envelope"></i>
								</span>
							</p>
						</div>
						<div class="field">
							<label class="label has-text-white" for="psw">{{ $t('resetpassword.password_label') }}</label>
							<p class="control has-icons-left">
								<input
									required
									id="psw"
									class="input"
									type="password"
									laceholder="$t('resetpassword.password_placeholder')"
									v-model="formData.password"
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-lock"></i>
								</span>
							</p>
						</div>
						<div class="field">
							<label
								class="label has-text-white" for="pswre"
							>{{ $t('resetpassword.repeat_password_label') }}</label
							>
							<p class="control has-icons-left">
								<input
									required
									id="pswre"
									class="input"
									type="password"
									placeholder="$t('resetpassword.repeat_password_placeholder')"
									v-model="repeatPassword"
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-lock"></i>
								</span>
							</p>
						</div>
						<progress
							v-if="isPending"
							class="progress is-small is-primary mt-5"
							max="100"
						/>
						<span v-if="error" class="tag is-danger is-medium is-light mt-5"> {{ $t(error) }}</span>
						<p v-if="successFeedback" class="has-text-success is-medium mt-5">
							{{ $t('resetpassword.success') }}
						</p>
					</div>
				</div>
				<div
					class="RecoverPassword-Actions px-6 py-4 is-flex is-align-items-center is-justify-content-space-between"
				>
					<router-link to="/login">{{ $t('resetpassword.back') }}</router-link>
					<button
						class="button is-info"
						type="submit"
						:disabled="isPending || disableSubmit"
					>
						 {{ $t('resetpassword.submit') }}
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	data: vm => ({
		formData: {
			token: vm.$route.params.token,
			password: '',
			email: vm.$route.params.email
		},

		repeatPassword: '',

		isPending: false,
		error: '',
		successFeedback: '',
		disableSubmit: false
	}),

	methods: {
		async onSubmit() {
			this.successFeedback = '';

			if (this.formData.password !== this.repeatPassword) {
				this.error = 'resetpassword.error_mismatch';
				return;
			}

			this.error = '';
			this.isPending = true;

			try {
				await this.$services.user.changePassword(this.formData);
				this.disableSubmit = true;
				this.successFeedback = true;
				this.formData.password = '';
				this.repeatPassword = '';
			} catch (error) {
				this.error = 'resetpassword.error_generic';
			} finally {
				this.isPending = false;
			}
		}
	}
};
</script>

<style>
.RecoverPassword {
  width: 100vw;
  height: 100vh;
  background: #23282d;
}

.RecoverPassword-Form {
  width: 500px;
  max-width: 90%;
  background-color: #363a41;
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  border: 1px solid #4a4e58;
}

.RecoverPassword-Title {
  color: white;
  margin-bottom: 40px;
  margin-top: 20px;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.08rem;
}

.RecoverPassword-Actions {
  background-color: #2d3138;
  border-top: 1px solid #4a4e58;
}
</style>
